// =====================================================================
// AIBoxHub — Site Configuration
// Single source of truth. Edit anything here (or via the Admin panel
// for products) without rebuilding the architecture.
// =====================================================================

export const BRAND = {
  name: "AIBoxHub",
  tagline: "Building the Future with AI & Smart Automation",
  whatsappPhone: "917994569544", // E.164 without "+"
  whatsappUrl: "https://wa.me/917994569544",
  whatsappMessage: "Hi%20AIBoxHub%2C%20I%27d%20like%20to%20know%20more",
  email: "hello@aiboxhub.com",
  phoneDisplay: "+91 79945 69544",
  phoneTel: "+917994569544",
  hqDisplay: "Global · AIBoxHub HQ",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d59581.69!2d76.94!3d11.01!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba85948b1d8e1f5%3A0x6e7e2f4c1b50e7!2sIndia!5e0!3m2!1sen!2sin!4v1700000000000",
};

export const waLink = (msg) =>
  `${BRAND.whatsappUrl}?text=${msg || BRAND.whatsappMessage}`;

// ---------------------------------------------------------------------
// Default products (used if admin has not added any products to DB yet)
// Each product is fully editable. Add as many as you want.
// ---------------------------------------------------------------------
export const DEFAULT_PRODUCTS = [
  {
    id: "queue",
    name: "AI Queue Pro",
    tag: "Flagship",
    description: "Token, queue & flow intelligence for clinics, hospitals & govt offices.",
    image: "https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=1200&q=80",
    price_from: 29,
    cta: "Explore",
    link: "/products/queue",
    active: true,
    order: 1,
  },
  {
    id: "salon",
    name: "AI Salon",
    tag: "Boutique",
    description: "Salon-grade booking, queue & loyalty automation.",
    image: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1200&q=80",
    price_from: 29,
    cta: "Explore",
    link: "/products/salon",
    active: true,
    order: 2,
  },
  {
    id: "hospital",
    name: "AI Hospital",
    tag: "Healthcare",
    description: "End-to-end hospital token, OPD & department coordination.",
    image: "https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=1200&q=80",
    price_from: 99,
    cta: "Explore",
    link: "/products/hospital",
    active: true,
    order: 3,
  },
  {
    id: "clinic",
    name: "AI Clinic",
    tag: "Healthcare",
    description: "Smart clinic system with patient flow, reminders & analytics.",
    image: "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=1200&q=80",
    price_from: 49,
    cta: "Explore",
    link: "/products/clinic",
    active: true,
    order: 4,
  },
  {
    id: "crm",
    name: "AI CRM",
    tag: "Sales",
    description: "Pipeline, contacts & AI-drafted follow-ups in one workspace.",
    image: "https://images.unsplash.com/photo-1552581234-26160f608093?w=1200&q=80",
    price_from: 49,
    cta: "Explore",
    link: "/products/crm",
    active: true,
    order: 5,
  },
  {
    id: "booking",
    name: "AI Booking",
    tag: "Services",
    description: "Multi-location bookings, payments and resource scheduling.",
    image: "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=1200&q=80",
    price_from: 29,
    cta: "Explore",
    link: "/products/booking",
    active: true,
    order: 6,
  },
  {
    id: "voice",
    name: "AI Voice Bot",
    tag: "Agent",
    description: "Branded voice agents for reception, sales & support — 24/7.",
    image: "https://images.unsplash.com/photo-1589254065878-42c9da997008?w=1200&q=80",
    price_from: 99,
    cta: "Explore",
    link: "/products/voice",
    active: true,
    order: 7,
  },
  {
    id: "suite",
    name: "AI Business Suite",
    tag: "Enterprise",
    description: "Bundle of everything: queue + CRM + voice + marketplace.",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=80",
    price_from: 299,
    cta: "Explore",
    link: "/products/suite",
    active: true,
    order: 8,
  },
];

// ---------------------------------------------------------------------
// AI Marketplace models. Edit links to point to your hosted endpoints.
// `live: true` opens the in-page Claude chat. Others link out.
// ---------------------------------------------------------------------
export const AI_MODELS = [
  { id: "chatgpt", name: "ChatGPT", vendor: "OpenAI", tier: "Premium", link: "https://chat.openai.com" },
  { id: "claude", name: "Claude", vendor: "Anthropic", tier: "Premium", live: true, link: "#chat-claude" },
  { id: "gemini", name: "Gemini", vendor: "Google", tier: "Premium", link: "https://gemini.google.com" },
  { id: "grok", name: "Grok", vendor: "xAI", tier: "Premium", link: "https://grok.x.ai" },
  { id: "deepseek", name: "DeepSeek", vendor: "DeepSeek", tier: "Free", link: "https://chat.deepseek.com" },
  { id: "llama", name: "Llama", vendor: "Meta", tier: "Free", link: "https://llama.meta.com" },
  { id: "perplexity", name: "Perplexity", vendor: "Perplexity", tier: "Premium", link: "https://perplexity.ai" },
  { id: "mistral", name: "Mistral", vendor: "Mistral", tier: "Free", link: "https://chat.mistral.ai" },
  { id: "image", name: "Image Generator", vendor: "AIBoxHub Studio", tier: "Premium", link: "/marketplace/image" },
  { id: "voice", name: "Voice AI", vendor: "AIBoxHub Studio", tier: "Premium", link: "/marketplace/voice" },
  { id: "video", name: "Video AI", vendor: "AIBoxHub Studio", tier: "Premium", link: "/marketplace/video" },
];

export const FOOTER_COLS = [
  {
    title: "Product",
    items: [
      { label: "AI Queue Pro", to: "/products/queue" },
      { label: "AI Marketplace", to: "/#marketplace" },
      { label: "AI Voice Bot", to: "/products/voice" },
      { label: "Pricing", to: "/#pricing" },
    ],
  },
  {
    title: "Solutions",
    items: [
      { label: "Hospitals", to: "/#industries" },
      { label: "Salons", to: "/#industries" },
      { label: "Government", to: "/#industries" },
      { label: "Enterprise", to: "/#industries" },
    ],
  },
  {
    title: "Company",
    items: [
      { label: "About", to: "/#about" },
      { label: "Blog", to: "/#blog" },
      { label: "Careers", to: "/legal/careers" },
      { label: "Contact", to: "/#contact" },
    ],
  },
  {
    title: "Legal",
    items: [
      { label: "Terms", to: "/legal/terms" },
      { label: "Privacy", to: "/legal/privacy" },
      { label: "Refund", to: "/legal/refund" },
      { label: "Documentation", to: "/legal/docs" },
      { label: "Support", to: "/#contact" },
    ],
  },
];

export const SOCIAL_LINKS = {
  twitter: "https://twitter.com/aiboxhub",
  linkedin: "https://linkedin.com/company/aiboxhub",
  github: "https://github.com/aiboxhub",
  email: "mailto:hello@aiboxhub.com",
};

export default {
  BRAND,
  DEFAULT_PRODUCTS,
  AI_MODELS,
  FOOTER_COLS,
  SOCIAL_LINKS,
  waLink,
};
